import React from 'react'
import AppLink from 'components/AppLink'
import AppLogo from 'components/AppLogo'
import withQueryParams from 'components/withQueryParams'
import { LayoutWithVertical as Layout } from 'stylist'
import { Route } from 'react-router-dom'

import RouteSignUpIndex from './sign-up/index'

const RouteSignUp = ({ match: { path }, query }) => (
  <Layout>
    <Layout.Header>
      <AppLink clientId={query.get('client_id')}>
        <AppLogo clientId={query.get('client_id')} />
      </AppLink>
    </Layout.Header>
    <Layout.Main>
      <Route path={path} exact component={RouteSignUpIndex} />
    </Layout.Main>
  </Layout>
)

export default withQueryParams(RouteSignUp)



// WEBPACK FOOTER //
// ./src/routes/sign-up.js